import type { users as en } from '@/i18n/locales/en/users';
import type { Translation } from '@/i18n/types';

export const users: Translation<typeof en> = {
  page: {
    title: 'Utilizadores',
    noScope:
      'Não tens nenhum âmbito administrativo, por isso não há lista de membros para mostrar.',
    departmentListsTitle: 'Listas de membros por departamento',
    leadCompany: 'Membros de {{company}}.',
    membersOf: 'Membros de {{company}}',
    companyMembersCardTitle: 'Membros',
    addPerson: 'Adicionar pessoa',
    empty: 'Sem membros.',
    name: 'Nome',
    email: 'E-mail',
    login: 'Acesso',
    source: 'Origem',
    yes: 'sim',
    no: 'não',
    invitePerson: 'Convidar',
    importCsv: 'Importar CSV',
    searchPlaceholder: 'Pesquisar por nome ou e-mail…',
    filterDepartment: 'Departamento',
    allDepartments: 'Todos os departamentos',
    filterLocation: 'Localização',
    allLocations: 'Todas as localizações',
    filterStatus: 'Estado',
    allStatuses: 'Todos os estados',
    employee: 'Funcionário',
    department: 'Departamento',
    location: 'Localização',
    lastSync: 'Última sincronização',
    consent: 'Consentimento',
    wearable: 'Wearable',
    pilot: 'Piloto',
    account: 'Conta',
    actions: 'Ações',
    accountActive: 'Ativo',
    accountDeactivated: 'Desativado',
    noLocation: 'Sem localização',
    noDepartment: 'Sem departamento',
    activation: {
      label: 'Ativação',
      invited: 'Convidado',
      activated: 'Ativado',
      active: 'Ativo',
      inactive: 'Inativo',
      deactivated: 'Desativado',
    },
    consentStatus: {
      pending: 'Pendente',
      confirmed: 'Confirmado',
      declined: 'Retirado',
      none: 'Nenhum',
    },
  },
  detail: {
    thisPerson: 'esta pessoa',
    edit: 'Editar',
    name: 'Nome',
    email: 'E-mail',
    nickname: 'Alcunha',
    preferredLanguage: 'Idioma preferido',
    region: 'Região',
    login: 'Acesso',
    yes: 'sim',
    no: 'não',
    gender: 'Género',
    birthdate: 'Data de nascimento',
    height: 'Altura',
    weight: 'Peso',
    privateNote:
      'Género, data de nascimento, altura e peso são privados para esta pessoa e não fazem parte do que mais ninguém vê dela.',
    actionsCardTitle: 'Ações',
    statsCardTitle: 'Estatísticas',
  },
  edit: {
    title: 'Editar dados pessoais',
    lead: 'O nome e o e-mail vêm da conta de início de sessão e não podem ser alterados aqui.',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  addPerson: {
    created: 'Pessoa criada.',
    inviteSent: 'Um e-mail de convite está a caminho.',
    alreadyHasLogin: 'Já têm acesso.',
    noLoginYet: 'Ainda não têm acesso — podes convidá-los mais tarde a partir da lista de membros.',
    done: 'Concluído',
    name: 'Nome',
    email: 'E-mail',
    emailHint: 'Opcional — com um, a pessoa é convidada a iniciar sessão.',
    nickname: 'Alcunha',
    region: 'Região',
    conflict:
      'Já existe uma pessoa com este endereço de e-mail{{reason}}. Adiciona essa pessoa existente ao âmbito em vez de criar um duplicado.',
    cancel: 'Cancelar',
    create: 'Criar pessoa',
    companyTitle: 'Adicionar uma pessoa à empresa',
    departmentTitle: 'Adicionar uma pessoa ao departamento',
    newPersonCardTitle: 'Nova pessoa',
    existingCardTitle: 'Membro existente da empresa',
    existingPersonCardTitle: 'Pessoa existente',
    member: 'Membro',
    person: 'Pessoa',
    choose: 'Escolhe…',
    addToDepartment: 'Adicionar ao departamento',
    addToCompany: 'Adicionar à empresa',
    searchPeople: 'Pesquisar pessoas',
    searchPlaceholder: 'Nome ou e-mail',
    noEligible: 'Não foi encontrada nenhuma pessoa correspondente.',
    editionMismatch:
      'A edição desta pessoa é diferente da da empresa. Muda primeiro a edição da pessoa ou da empresa e tenta novamente.',
  },
  actions: {
    invite: 'Convidar',
    inviteAgain: 'Convidar novamente',
    changeEmail: 'Alterar e-mail',
    newEmail: 'Novo endereço de e-mail',
    save: 'Guardar',
    cancel: 'Cancelar',
    remove: 'Remover',
    unlink: 'Desvincular',
    unlinkFromPilot: 'Desvincular do piloto',
    erase: 'Eliminar',
    changeLocation: 'Alterar localização',
    changeDepartment: 'Alterar departamento',
    deactivate: 'Desativar',
    activate: 'Ativar',
  },
  invite: {
    title: 'Convidar uma pessoa',
    name: 'Nome',
    email: 'Endereço de e-mail',
    role: 'Função',
    roleMember: 'Funcionário',
    roleAdmin: 'Administrador da empresa',
    submit: 'Convidar',
    cancel: 'Cancelar',
  },
  import: {
    title: 'Importar CSV',
    instructions: 'Cola ou carrega um CSV com as colunas: nome, e-mail, departamento, localização.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Ou carrega um ficheiro',
    submit: 'Importar',
    cancel: 'Cancelar',
    done: 'Concluído',
    summary: '{{imported}} importados, {{failed}} falhados.',
    rowLabel: 'Linha {{row}}',
    rowSuccess: 'Importado',
    rowFailed: 'Falhou',
  },
};
